import React from "react";

const Devider = () => {
  return <div className="devider"></div>;
};

export default Devider;
